module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nvar device, breakPoint, index, imageIndex;\nfor(device in model.images){\n%>\n<div class=\"deviceContainer\">\n<div class=\"containerTitle\"><%= device %></div>\n<%\nfor(breakPoint in model.images[device]){\n%>\n<div class=\"breakPointContainer\">\n<div class=\"containerTitle\"><%= breakPoint %></div>\n<%\nfor(imageIndex in model.images[device][breakPoint]){\n%>\n<%- include('thumb', { resourceData: model.images[device][breakPoint][imageIndex] }); %>\n<%\n}\n%>\n</div>\n<%\n}\n%>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\mediaManagement\\imageAssignmentDetails\\renderedImageList.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
var device, breakPoint, index, imageIndex;
for(device in model.images){

    ; __line = 5
    ; __append("\n<div class=\"deviceContainer\">\n<div class=\"containerTitle\">")
    ; __line = 7
    ; __append(escapeFn( device ))
    ; __append("</div>\n")
    ; __line = 8
    ; 
for(breakPoint in model.images[device]){

    ; __line = 10
    ; __append("\n<div class=\"breakPointContainer\">\n<div class=\"containerTitle\">")
    ; __line = 12
    ; __append(escapeFn( breakPoint ))
    ; __append("</div>\n")
    ; __line = 13
    ; 
for(imageIndex in model.images[device][breakPoint]){

    ; __line = 15
    ; __append("\n")
    ; __line = 16
    ; __append( include('thumb', { resourceData: model.images[device][breakPoint][imageIndex] }) )
    ; __append("\n")
    ; __line = 17
    ; 
}

    ; __line = 19
    ; __append("\n</div>\n")
    ; __line = 21
    ; 
}

    ; __line = 23
    ; __append("\n</div>\n")
    ; __line = 25
    ; 
}

    ; __line = 27
    ; __append("\n</div>")
    ; __line = 28
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\mediaManagement\imageAssignmentDetails\renderedImageList.ejs

}